let ADDRESS = {};
let shouldSubmitRegister = true;
ADDRESS.init = function () {
  let passwordSelector = 'input#customerPassword';
  let passwordHiddenSelector = 'input#customerPasswordhdn';

  $('#showPassword').change(function () {
    let isChecked = $(this).is(':checked');
    if (isChecked) {
      $(passwordSelector).css('display', 'none');
      $(passwordHiddenSelector).css('display', 'inline-block');
    } else {
      $(passwordSelector).css('display', 'inline-block');
      $(passwordHiddenSelector).css('display', 'none');
    }
  });

  $(passwordSelector).change(function () {
    $(passwordHiddenSelector).val($(this).val());
  });

  $(passwordHiddenSelector).change(function () {
    $(passwordSelector).val($(this).val());
  });

  $('.shipping__address input[type=radio]').change(function () {
    disableBillingAddressOption();
  });

  cleanForm();

  // Prevent multiple submits of the registration form
  $('#newCustomerAddress').submit(function (e) {
    if (shouldSubmitRegister) shouldSubmitRegister = false;
    else e.preventDefault();
  });
};

function disableBillingAddressOption() {
  let unsupportedPanel = $('.js-invoiceUnsupported');
  let unsupportedInput = $('.js-invoiceUnsupported input');
  let normalAddressInput = $(
    '.billing__address__options .normal__address input'
  );
  let normalAddressForm = $(
    '.billing__address__options .normal__address .form__panel'
  );

  unsupportedPanel.removeClass('accordion__disabled');
  unsupportedInput.attr('disabled', false);
  if (checkIfFormEmpty(normalAddressForm)) {
    unsupportedInput.prop('checked', true);
    normalAddressInput.prop('checked', false);
    unsupportedInput.trigger('change');
  }
}

function cleanForm() {
  $('.shipping__address .accordion__panel:not(.active)').each(function () {
    $(this)
      .find('.ERROR')
      .each(function () {
        $(this).removeClass('ERROR');
        $(this).val('');
      });
  });
}

function checkIfFormEmpty(formContainer) {
  let empty = true;
  formContainer.find('input').each(function () {
    if ($(this).val() !== '') {
      empty = false;
      return false;
    }
  });

  return empty;
}

export default ADDRESS;
